export function getParam(param: string): string {
    // Take any param out of the page query params
    const search: any = location.search.replace(/&amp;/g, '&').replace('?', '').split('&');
    let value = '';

    search.map((item: any, index: number) => {
      const values: string = item.split('=');
      if (values[0] === param) {
        value = values[1];
      }
    });

    return value;
}